import { Eye, EyeOff } from "lucide-react";
import { SelectTheme } from "../../components/SelectTheme";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { BaseUrlApi, ErrorMessage } from "../../lib/api";
import Cookie from "js-cookie";
import axios from "axios";
import { Link } from "react-router-dom";

export default function LoginPage() {
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);

  const [form, setForm] = useState({
    identifier: "",
    password: "",
  });

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      setErrors({});
      const { data } = await axios.post(`${BaseUrlApi}/login`, form);
      Cookie.set("token", data.access_token, { expires: 365 });
      toast("تسجيل دخول ناجح", {
        description: "لقد قمت بتسجيل الدخول الآن، استمتع 👋",
      });
      navigate("/", { replace: true });
    } catch (error) {
      const result = ErrorMessage(error);
      if (typeof result !== "object")
        toast("Error", {
          description: result,
        });
      setErrors(result);
      Cookie.remove("token");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen bg-background" dir="rtl">
      {/* Left Section */}
      <div className="relative hidden w-1/2 p-8 lg:block">
        <div className="h-full w-full overflow-hidden rounded-[40px] bg-gradient-to-b from-secondaryColor via-mainColor to-background text-white">
          <div className="flex h-full flex-col items-center justify-center px-8 text-center">
            <div className="mb-8">
              <h1 className="text-2xl font-semibold">فريق أساكيب</h1>
            </div>
            <h2 className="mb-6 text-4xl font-bold">مرحباً بعودتك</h2>
            <p className="mb-12 text-lg">
              سجل دخولك لمتابعة تقدم عملك في شركة أساكيب.
            </p>

            <div className="w-full max-w-sm space-y-4">
              <div className="rounded-lg bg-primary-foreground/10 p-4 backdrop-blur-sm">
                <div className="flex items-center gap-4">
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-white text-black">
                    ١
                  </span>
                  <span className="text-lg">تسجيل الدخول إلى حسابك</span>
                </div>
              </div>
              <div className="rounded-lg bg-primary-foreground/5 p-4 backdrop-blur-sm">
                <div className="flex items-center gap-4">
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-foreground/20">
                    ٢
                  </span>
                  <span className="text-lg">تتبع مشاريعك</span>
                </div>
              </div>
              <div className="rounded-lg bg-primary-foreground/5 p-4 backdrop-blur-sm">
                <div className="flex items-center gap-4">
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-foreground/20">
                    ٣
                  </span>
                  <span className="text-lg">التعاون مع فريقك</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Right Section */}
      <div className="flex w-full items-center justify-center bg-background p-6 lg:w-1/2">
        <div className="w-full max-w-md rounded-[40px]">
          <div className="mx-auto max-w-sm">
            <div className="flex justify-between items-center">
              <h2 className="text-3xl font-bold text-foreground mb-2">
                تسجيل الدخول
              </h2>
              <SelectTheme />
            </div>
            <p className="mb-8 text-muted-foreground">
              أدخل بيانات الاعتماد الخاصة بك للوصول إلى حسابك.
            </p>

            <form className="space-y-4" onSubmit={handleLogin}>
              <div className="space-y-2">
                <Input
                  className="h-12 text-right"
                  placeholder="أدخل بريدك الإلكتروني"
                  type="email"
                  value={form.identifier}
                  onChange={(e) =>
                    setForm({ ...form, identifier: e.target.value })
                  }
                />
                {errors?.identifier && (
                  <p className="text-red-500 font-semibold text-sm">
                    {errors.identifier[0]}
                  </p>
                )}
              </div>

              <div className="space-y-2">
                <div className="relative">
                  <Input
                    className="h-12 text-right"
                    placeholder="أدخل كلمة المرور"
                    type={showPassword ? "text" : "password"}
                    value={form.password}
                    onChange={(e) =>
                      setForm({ ...form, password: e.target.value })
                    }
                  />

                  <div
                    className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground cursor-pointer"
                    onClick={(e) => {
                      e.preventDefault();
                      setShowPassword(!showPassword);
                    }}
                  >
                    {showPassword ? (
                      <EyeOff className="h-5 w-5" />
                    ) : (
                      <Eye className="h-5 w-5" />
                    )}
                  </div>
                </div>
                {errors?.password && (
                  <p className="text-red-500 font-semibold text-sm">
                    {errors.password[0]}
                  </p>
                )}
                <div className="flex justify-start">
                  <Link
                    to="/forgot-password"
                    className="text-sm text-primary hover:underline"
                  >
                    نسيت كلمة المرور؟
                  </Link>
                </div>
              </div>

              <Button className="h-12 w-full" disabled={loading}>
                {loading ? "جاري تسجيل الدخول..." : "تسجيل الدخول"}
              </Button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
